{
  "agencies.agencyCTA": "Agentur anschauen",
  "agencies.featuredAgenciesDescriptionsTitle": "Über uns",
  "agencies.featuredAgenciesGenericDescription": "Wir sind dein vertrauenswürdiger Partner in der Immobilienbranche. Unser engagiertes Team bietet dir fachkundige Beratung und persönlichen Service bei jedem Schritt.",
  "agencies.featuredAgenciesPreviewBadge": "Vorschau",
  "agencies.featuredAgenciesServicesTitle": "Dienstleistungen",
  "agencyDirectorySeoLinks.childTitle.canton": "Agenturen in Kantonen der {location}",
  "agencyDirectorySeoLinks.childTitle.country": "Agenturen in Ländern von {location}",
  "agencyDirectorySeoLinks.childTitle.default": "Agenturen in der Nähe von {location}",
  "agencyDirectorySeoLinks.childTitle.district": "Agenturen in Bezirken von {location}",
  "agencyDirectorySeoLinks.childTitle.municipality": "Agenturen in Orten von {location}",
  "agencyDirectorySeoLinks.childTitle.place": "Agenturen in Orten von {location}",
  "agencyDirectorySeoLinks.childTitle.region": "Agenturen in Regionen von {location}",
  "agencyDirectorySeoLinks.title": "Immobilienagenturen in der Nähe finden",
  "agencyFocus.any": "Alle",
  "agencyFocus.rentProperties": "Mietobjekte",
  "agencyFocus.saleProperties": "Verkaufsobjekte",
  "agencyFocusText": "Agentur-Spezialisierung",
  "agentFocusText": "Agenten-Fokus",
  "agentFocus.newConstruction": "Neubau",
  "agencyList.aboutUs": "Über uns",
  "agencyList.agencyTextPlural": "Agenturen",
  "agencyList.agencyTextSingular": "Agentur",
  "agencyList.featuredAgencies": "Dein Immobilienexperte vor Ort",
  "agencyList.loading": "Wird geladen...",
  "agencyList.noAgenciesFound": "Keine Agentur gefunden",
  "agencyList.rentProperties": "Immobilien zu vermieten",
  "agencyList.saleProperties": "Immobilien zu verkaufen",
  "agencyList.searchResults": "{numberOfResult} Agenturen in {location}",
  "agencyList.sorting.default": "Empfohlen",
  "agencyList.tryAnotherLocation": "Versuche es an einem anderen Ort",
  "agentList.expertAt": "Immobilienexperte bei",
  "agentList.loadFailed": "Makler konnten nicht geladen werden",
  "agentList.noAgentsFound": "Kein Makler gefunden",
  "agentList.tryAgainLater": "Bitte versuche es später erneut",
  "agentList.forRent": "{count} Miete",
  "agentList.forSale": "{count} Verkauf",
  "agentList.listings": "{count} Inserate",
  "agentList.searchResults": "{numberOfResult} Makler in {location}",
  "agentList.sold": "{count} verkauft",
  "agentServices.generalContracting": "Bauprojekte",
  "agentServices.marketing": "Vermarktung",
  "agentServices.realEstateManagement": "Immobilienverwaltung",
  "agentServices.sales": "Verkauf",
  "agentServices.valuation": "Bewertung",
  "agentSpecializations.commercialOffice": "Gewerbe & Büro",
  "agentSpecializations.firstRentals": "Erstvermietung",
  "agentSpecializations.initialMarketing": "Erstvermarktung",
  "agentSpecializations.investmentProperties": "Renditeliegenschaften",
  "agentSpecializations.luxuryProperties": "Luxusimmobilien",
  "breadcrumbs.agencyDirectory": "Alle Agenturen",
  "breadcrumbs.agentDirectory": "Alle Makler",
  "breadcrumbs.homepage": "Startseite",
  "searchBox.buttonText": "Agenturen suchen",
  "searchBox.inputBox.label": "Ort",
  "searchBox.inputBox.placeholder": "Ort, Region, PLZ, Land",
  "searchBox.noLocationSelectedWarning": "Bitte gib mindestens einen Ort, Region, PLZ, etc. ein.",
  "searchBox.resultButtonText": "Treffer",
  "searchTypeToggle.agency": "Agentur",
  "searchTypeToggle.agent": "Makler",
  "searchTypeToggle.label": "Suche nach",
  "seo.pageDescriptionLocationSpecific": "Vergleiche Agenturen in [Location], sortiert nach Nähe und Anzahl Transaktionen in den letzten 24 Monaten.",
  "seo.pageDescriptionNational": "Finde den besten Immobilienmakler in der Schweiz für dein Projekt – basierend auf aktuellen Verkäufen, Kundenbewertungen und der Nähe zu deiner Immobilie.",
  "seo.pageTitleLocationSpecific": "Immobilienagenturen in [Location] ([Zip Code]) | [Brand]",
  "seo.pageTitleNational": "Liste der besten Immobilienmakler in der Schweiz | [Brand]",
  "sortingDropdown.alphabetically": "Alphabetisch",
  "sortingDropdown.rentPropertyCount.high": "Anzahl Mietobjekte: hoch",
  "sortingDropdown.salePropertyCount.high": "Anzahl Verkaufsobjekte: hoch",
  "sortingDropdown.topResults": "Vollständigkeit des Profils",
  "subHeading": "Mit einer einfachen Suche findest du den perfekten Partner für deine Bedürfnisse."
}
